module.exports = __webpack_public_path__ + "static/media/dr-isioma-okobah-foundation-medical.adce0001.JPG";